import React from 'react';
import '../styles/global.css'; // Predpokladám, že máte tento súbor so základnými štýlmi

const Contacs = () => {
  const address = "JUDr. KAROL PLANK Advokátska kancelária, s.r.o.\nŠtúrova 13, 810 00 Bratislava";
  const email = "karolplank@gmail.com";
  const phone = "0905 135 422";
  const googleMapsEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3726.556735464856!2d17.112093612679573!3d48.14260595069034!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476c894182473371%3A0x6041a55d0ea7462a!2s%C5%A0t%C3%BArova%2024%2F13%2C%20811%2002%20Bratislava!5e1!3m2!1ssk!2ssk!4v1745837393003!5m2!1ssk!2ssk";

  return (
    <div className="contact-page">
      <div className="contact-info">
        <h2>Kontaktujte nás</h2>
        <p className="address">
          {address.split('\n').map((item, key) => {
            return <span key={key}>{item}<br/></span>;
          })}
        </p>
        <p className="email">
          Email: <a href={`mailto:${email}`}>{email}</a>
        </p>
        <p className="phone">
          Telefón: <a href={`tel:${phone.replace(/\s/g, '')}`}>{phone}</a>
        </p>
      </div>
      <div className="contact-map">
        <iframe
          src={googleMapsEmbedUrl}
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Adresa na mape"
        ></iframe>
      </div>
    </div>
  );
};

export default Contacs;